<div *ngIf="userProfile$ | async" class="dashboard">
    <!-- Logo -->
    <div class="dashboard__logo-container">
        <img
            class="dashboard__logo"
            *ngIf="organization$ | async as organization" 
            [src]="organization.group_logos.default">
    </div>

    <!-- Controls -->
    <div *ngIf="!isEmpty || (organization$ | async)" class="dashboard__header">
        <div>
            <app-collection-picker
                class="mr-4"
                *ngIf="organization$ | async"
                [selectionLabel]="userSelectionLabel"
                (privateSelected)="handleSelectPrivate()"
                (organizationSelected)="handleSelectOrganization($event)"
                (collectionSelected)="handleSelectCollection($event)">
            </app-collection-picker>

            <app-bookmarks-sort
                class="mr-4"
                (sort)="handleBookmarksSort($event)"
                [selection]="sort$ | async">
            </app-bookmarks-sort>

            <app-gallery-view-mode></app-gallery-view-mode>
        </div>

        <ng-container *ngIf="{ bookmarks: bookmarks$ | async, checkedBookmarks: checkedBookmarks$ | async, exporting: exporting$ | async } as selectState">
            <div class="hide-sm" *ngIf="!selectState.exporting">

                <button
                app-button
                buttonTheme="light"
                buttonType="flat"
                *ngIf="selectState.checkedBookmarks.length !== selectState.bookmarks.length"
                class="hide-sm"
                (click)="handleSelectAllClick()">
                    Select All
                </button>
                
                <button
                    *ngIf="selectState.checkedBookmarks.length"
                    class="ml-2"
                    app-button
                    buttonTheme="light"
                    buttonType="flat"
                    [matMenuTriggerFor]="selectionMenu">
                        {{ selectState.checkedBookmarks.length }} Items Selected <fa-icon icon="caret-down"></fa-icon>
                </button>

                <mat-menu #selectionMenu="matMenu">
                    <button mat-menu-item (click)="handleClearSelectionClick()">Clear Selection</button>
                    <button mat-menu-item (click)="handleExportSelectionClick()">Export CSV</button>
                </mat-menu>

            </div>
            
            <button
                *ngIf="selectState.exporting"
                app-button
                buttonTheme="light"
                buttonType="flat"
                disabled="true">
                    Exporting <app-spinner render="inline" size="medium" class="ml-2"></app-spinner>
            </button>
            
        </ng-container>
    </div>

    <!-- Empty message  -->
    <div *ngIf="isEmpty">
        <app-dashboard-message
            icon="bookmark"
            class="explore__message">
            <a [routerLink]="['/explore']" class="text-link">Go to the Explore tab</a> to browse & save 3D models to your dashboard.
        </app-dashboard-message>
    </div>
    
    <!-- Results -->
    <div class="dashboard__results" *ngIf="!isEmpty">
        <app-gallery-results
            [loading]="loading$ | async"
            [results]="bookmarks$ | async" 
            [checkable]="true"
            [checkedResults]="checkedBookmarks$ | async"
            (selectBookmark)="handleSelectBookmark($event)"
            (checkedChange)="handleCheckedChange($event)"
            [showActions]="true"
            [viewMode]="viewMode$ | async"
            selectLabel="View"
            *ngIf="bookmarks$ | async">

            <ng-template #galleryActions let-item>
                <app-bookmark-actions
                    theme="light"
                    [bookmark]="item" 
                    [bookmarkActions]="getBookmarkActions(item)"
                    [bookmarkType]="item.type"
                    [bookmarkEmbedTypes]="['bookmark', 'module']">
                </app-bookmark-actions>
            </ng-template>

            <ng-template #galleryTags let-item>
                <app-list listType="commafied">
                    <!-- Premium -->
                    <app-list-item *ngIf="item.premium && !(userProfile$ | async)?.premium_account_valid">
                        <fa-icon icon="lock"></fa-icon> Premium
                    </app-list-item>
        
                    <!-- View Only -->
                    <app-list-item *ngIf="!canEdit(item)">
                        <fa-icon icon="eye" class="mr-1"></fa-icon> View Only
                    </app-list-item>

                    <!-- Animated -->
                    <app-list-item *ngIf="item.animated">
                        Animated
                    </app-list-item>
        
                    <!-- Tour -->
                    <app-list-item *ngIf="item.tour">
                        Tour
                    </app-list-item>

                    <!-- Favorite -->
                    <app-list-item *ngIf="item.favorite">
                        Favorite
                    </app-list-item>
                </app-list>
            </ng-template>
        </app-gallery-results>
    </div>
</div>